// extracted by mini-css-extract-plugin
module.exports = {"debitAgree":"DebitAgreement_debitAgree__tgQxJ","optInLabel":"DebitAgreement_optInLabel__xPSl9","terms":"DebitAgreement_terms__N8lAL"};